import { FiArrowRight } from "react-icons/fi";

const Point = props => {
	return (
		<div className='d-flex '>
			<FiArrowRight size={30} className="me-2" />
			<p>{props.point}</p>
		</div>
	)
}

export default Point;